import React from "react";
import {
  transitions,
  positions,
  types,
  Provider as AlertProvider,
} from "react-alert";

const SuccessIcon = () => (
  <BaseIcon color="#67d45b">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </BaseIcon>
);
const BaseIcon = ({ color, pushRight = true, children }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: pushRight ? "20px" : "0", minWidth: 24 }}
  >
    {children}
  </svg>
);

export const AlertTemplate = ({ style, options, message, close }) => (
  <div
    style={{
      backgroundColor: "#5d3ebc",
      color: "white",
      padding: "10px",
      textTransform: "capitalize",
      borderRadius: "3px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0px 2px 2px 2px rgba(0, 0, 0, 0.03)",
      fontFamily: "Arial",
      width: 300,
      boxSizing: "border-box",
      fontSize: 16,
    }}
  >
    {options.type === "success" && <SuccessIcon />}
    <span style={{ flex: 2 }}>{message}</span>
  </div>
);

export const options = {
  position: positions.MIDDLE,
  timeout: 3000,
  offset: "30px",
  type: types.SUCCESS,
  transition: transitions.FADE,
  containerStyle: { zIndex: 10000 },
};
